module.exports = {"history":"História"}